module.exports = __webpack_public_path__ + "static/media/Mahindra_01.915bae83.jpg";